require('./bootstrap');

import Vue from 'vue';
import { InertiaApp } from '@inertiajs/inertia-vue';
import PortalVue from 'portal-vue';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

import router from './router';
import store from './Store/store';
import vuetify from './Plugins/vuetify';
import './Plugins/base';
import './Plugins/vuetify-mask';

Vue.mixin({ methods: { route } });
Vue.use(InertiaApp);
Vue.use(PortalVue);
Vue.use(VueMoment, { moment });

const app = document.getElementById('app');
const pages = require.context('./Pages', true, /\.vue$/);

new Vue({
    router,
    store,
    vuetify,
    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: name => pages(`./${name}.vue`).default,
        },
    }),
}).$mount(app);
